import { render, staticRenderFns } from "./TypeTag.vue?vue&type=template&id=9132704a&"
import script from "./TypeTag.vue?vue&type=script&lang=js&"
export * from "./TypeTag.vue?vue&type=script&lang=js&"
import style0 from "./TypeTag.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports